import { Box } from '@material-ui/core';

import { Font } from '../../../../../shared/components/Font';
import { Text } from '../../../../../shared/components/Text';

interface SectionTitleProps {
  titleId: string;
  textId?: string;
}

export const SectionTitle = ({ titleId, textId }: SectionTitleProps) => {
  return (
    <>
      <Font variant={'h4'} color={'title'}>
        <strong>
          <Text tId={titleId} />
        </strong>
      </Font>
      <Box mt={2} />
      {textId && (
        <>
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={textId} />
          </Font>
          <Box mt={2} />
        </>
      )}
    </>
  );
};
